import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    "https://antiquewhite-fish-651244.hostingersite.com",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;